import { CustomTabs, CustomToast } from "../../../shared"
import { TopBar } from "../../../widgets"
import MyReservationSkeleton from "../../../components/skeleton/my/myReservationSkeleton";
import { useGetMyReservationHistory } from "./model";
import './index.css'
import PendingReservation from "./ui/pendingReservation";
import ConfirmReservation from "./ui/confirmedReservation";
import CompleteReservation from "./ui/completeReservation";
import CancelReservation from "./ui/canceledReservation";
import dayjs from "dayjs";
import { useMyContext } from "../../../entities/context";
import { ReactComponent as Check } from "../../../assets/images/icon/check.svg"
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ReservationHistory = () => {
    const { data: reservationList, isLoading } = useGetMyReservationHistory();
    const { myReservationHistoryTabKey } = useMyContext();
    const [toastStatus, setToastStatus] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.state || location.state.status !== 'cancel-success') return;
        setToastStatus(true)
        navigate(location.pathname + location.search, { state: null });
    }, [])

    return <>
        {isLoading && <MyReservationSkeleton />}
        <TopBar title="예약 내역" rightIcon={false} position='fixed' thema='dark' navigates={{ left: '/my' }} />
        <CustomTabs items={[
            {
                key: 0,
                label: '예약 대기',
                children: <>
                    <div style={{ padding: '24px 20px 0' }}>
                        {reservationList && <PendingReservation reservationList={reservationList
                            .filter((reservation: IGetMyReservationHistoryResponse) => reservation.reservationType === '예약 대기' || reservation.reservationType === '결제 요청')
                            .sort((a, b) => {
                                if (a.requestPaidDateTime && b.requestPaidDateTime) {
                                    return dayjs(b.requestPaidDateTime).diff(a.requestPaidDateTime)
                                } else if (a.requestPaidDateTime && !b.requestPaidDateTime) {
                                    return -1
                                } else if (!a.requestPaidDateTime && b.requestPaidDateTime) {
                                    return 1
                                } else {
                                    return dayjs(b.reservationDateTime).diff(a.reservationDateTime)
                                }
                            })
                        } />}
                    </div>
                </>
            },
            {
                key: 1,
                label: '예약 확정',
                children: <>
                    <div style={{ padding: '24px 20px 0' }}>
                        {reservationList && <ConfirmReservation reservationList={reservationList
                            .filter((reservation: IGetMyReservationHistoryResponse) => reservation.reservationType === '예약 확정' && dayjs(reservation.startDateTime).isAfter(dayjs().add(-3, 'hour')))
                            .sort((a, b) => dayjs(a.startDateTime).diff(b.startDateTime))} />}
                    </div>
                </>
            },
            {
                key: 2,
                label: '이용 완료',
                children: <>
                    <div style={{ padding: '12px 20px 0' }}>
                        {reservationList && <CompleteReservation reservationList={reservationList
                            .filter((reservation: IGetMyReservationHistoryResponse) => reservation.reservationType === '이용 완료')
                            .sort((a, b) => dayjs(b.reservationDateTime).diff(a.reservationDateTime))} />}
                    </div>
                </>
            },
            {
                key: 3,
                label: '예약 취소',
                children: <>
                    <div style={{ padding: '12px 20px 0' }}>
                        {reservationList && <CancelReservation reservationList={reservationList
                            .filter((reservation: IGetMyReservationHistoryResponse) => reservation.reservationType === '예약 취소' || reservation.reservationType === "환불 완료")
                            .sort((a, b) => dayjs(b.reservationDateTime).diff(a.reservationDateTime))} />}
                    </div>
                </>
            },
        ]}
            defaultkey={myReservationHistoryTabKey} />
        {toastStatus && <CustomToast setToast={setToastStatus} text={<><Check width={16} height={16} stroke={'#000000'} />예약 취소를 완료했습니다.</>} />}
    </>
}

export default ReservationHistory